<template>
  <LandingNavbar />
  <LandingHeader />
  <!--
    Testimonials ausgeklammert, bis diese vorliegen
    <LandingTestimonial />
    <LandingAudience />
  -->
  <LandingCompass />
  <LandingFeatures />
  <LandingCallToAction />
  <LandingPricing />
  <LandingQuestions />
  <LandingNewsletter />
  <LandingFooter />
</template>

